<div class="flex flex-row h-full w-full">
  <!--TODO: Cambiar check de authority -->
  @if (userLogged.authorities.includes('CFG_LOGIN_MANAGER')) {
    <div class="flex flex-col background-sidebar transition-all ease-out" [class]="{ 'min-w-16': !isExpanded, 'min-w-60': isExpanded }">
      <div class="height-menus justify-between flex flex-row items-center">
        @if (isExpanded) {
          <img class="p-1" src="assets/img/logos/logo_ratenow_admin.svg" />
        }
        <div class="text-neutral-700 w-full text-center">
          <button mat-icon-button (click)="isExpanded = !isExpanded">
            <mat-icon class="menu-icon" [svgIcon]="'mat:menu'"></mat-icon>
          </button>
        </div>
      </div>
      <mat-divider class="dividers"></mat-divider>
      <div class="flex flex-col h-full">
        @for (menuItem of menuItems; track menuItem) {
          <div class="nav-item py-2.5" [class]="{ 'pt-3': $first, 'hidden': menuItem.hidden }" (click)="goUrl(menuItem.url)">
            <button class="pl-4" mat-icon-button [class]="{ 'text-primary-500': routeSelected.includes(menuItem.url) }">
              <mat-icon class="menu-icon" [svgIcon]="'mat:' + menuItem.icon"></mat-icon>
            </button>
            @if (isExpanded) {
              <h6 [class]="{ 'text-black': routeSelected.includes(menuItem.url) }" class="font-semibold truncate">
                {{ menuItem.name | translate }}
              </h6>
            }
            <!--<img
            *ngIf="isExpanded && menuItem.url.includes('edit-surveys')"
            class="h-9 aspect-auto"
            src="assets/img/logos/logo_ratenow_editor.svg"
            />-->
            @if (isExpanded && menuItem.url.includes('edit-surveys')) {
              <mat-icon class="h-9 aspect-auto ml-auto mr-3" svgIcon="mat:open_in_new"></mat-icon>
            }
          </div>
          @if (menuItem.expanded) {
            <div [@expandOnEnter] [@collapseOnLeave]>
              @for (submenuItem of menuItem.children; track submenuItem) {
                <div
                  class="pl-4 nav-item py-2.5 bg-neutral-100"
                  [class]="{ 'pt-3': $first, 'hidden': submenuItem.hidden }"
                  (click)="goSubUrl(submenuItem.buildUrl)"
                >
                  <button
                    [class]="{ 'pl-4': isExpanded, 'pl-1': !isExpanded, 'text-primary-500': routeSelected.includes(submenuItem.url) }"
                    class="transition-all"
                    mat-icon-button
                  >
                    <mat-icon class="menu-icon" [svgIcon]="'mat:' + submenuItem.icon"></mat-icon>
                  </button>
                  @if (isExpanded) {
                    <h6 [class]="{ 'text-black': routeSelected.includes(submenuItem.url) }" class="font-semibold truncate">
                      {{ submenuItem.name | translate }}
                    </h6>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  }
  <mat-divider class="dividers" [vertical]="true"></mat-divider>
  <div class="flex flex-col w-full bg-[#f3f4f7]">
    <mat-toolbar class="height-menus text-neutral-700 pr-0 background-sidebar flex justify-between z-10">
      <!--Logo-->
      <div class="flex flex-row">
        <div
          class="p-1 mr-4 cursor-pointer rounded-full hover:bg-primary-50 active:bg-primary-100"
          (click)="userLogged.authorities.includes('CFG_LOGIN_MANAGER') ? goUrl('/account-settings/about') : goUrl('/account-settings/about')"
        >
          <!--TODO: Cambiar url si es necesario-->
          <mat-icon color="primary" class="primary-icon" [svgIcon]="'mat:home'"></mat-icon>
        </div>
        @for (r of breadcrumb | slice: 1; track r; let i = $index; let f = $first; let l = $last) {
          <div class="flex flex-row">
            <div class="text-primary content-center">
              <mat-icon [svgIcon]="'mat:keyboard_arrow_right'"></mat-icon>
            </div>
            @if (!l) {
              <div
                (click)="buildUrlHastaAqui(r)"
                class="px-5 pt-1 capitalize cursor-pointer rounded-md text-primary hover:bg-primary-50 active:bg-primary-100 justify-center"
              >
                {{ getRouteText(r) }}
              </div>
            }
            @if (l) {
              <div class="px-5 pt-1 capitalize">{{ r }}</div>
            }
          </div>
        }
      </div>
      <div class="height-menus flex flex-row">
        <mat-divider class="dividers" [vertical]="true"></mat-divider>
        <div class="toolbar-action" [matMenuTriggerFor]="langMenu">
          <span class="text-xl">{{ translateService.currentLang }}</span>
        </div>
        <mat-menu #langMenu="matMenu">
          <button mat-menu-item (click)="changeLang('ca')">ca</button>
          <button mat-menu-item (click)="changeLang('de')">de</button>
          <button mat-menu-item (click)="changeLang('en')">en</button>
          <button mat-menu-item (click)="changeLang('es')">es</button>
          <button mat-menu-item (click)="changeLang('fr')">fr</button>
          <button mat-menu-item (click)="changeLang('it')">it</button>
        </mat-menu>
        <mat-divider class="dividers" [vertical]="true"></mat-divider>
        <div #megaMenuOriginRef class="toolbar-action" (click)="openMegaMenu(megaMenuOriginRef)">
          <span class="text-sm">Apps</span>
          <mat-icon class="menu-icon" [svgIcon]="'mat:apps'"></mat-icon>
        </div>
        <mat-divider class="dividers" [vertical]="true"></mat-divider>
        <div class="toolbar-action" (click)="logOut()">
          <span class="text-sm">{{ 'admin-users.log-out' | translate }}</span>
          <mat-icon class="menu-icon" [svgIcon]="'mat:logout'"></mat-icon>
        </div>
        <mat-divider class="dividers" [vertical]="true"></mat-divider>
        <div class="w-16 place-items-center content-center cursor-pointer" (click)="goUrl('account-settings')">
          <div class="relative">
            <div class="rounded-full h-11 w-11 bg-primary"></div>
            <div class="absolute -right-1 -bottom-1 z-20">
              <mat-icon [svgIcon]="'mat:account_circle'"></mat-icon>
            </div>
          </div>
        </div>
      </div>
    </mat-toolbar>
    <mat-divider class="dividers"></mat-divider>
    <!-- ================================================================= -->
    <!-- ************************* MAIN CONTAINER ************************ -->
    <!-- ================================================================= -->
    <div class="w-full h-full z-10 overflow-auto relative">
      @if (loading) {
        <div class="absolute h-full w-full z-30 bg-neutral-300/50 flex justify-center items-center">
          <mat-spinner class="w-40 h-40"></mat-spinner>
        </div>
      }
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div class="absolute top-0 right-0">
  <img src="assets/img/logos/background_admin_users.svg" />
</div>
